// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1__Gb","cls2":"AccountMenuButton-cls2_bAX AccountMenuButton-cls1__Gb"};